var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-5.0 -10.0 110.0 135.0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.504 45.094-4.8438 4.8867c-1.4922 1.5078-1.5508 3.918-0.12891 5.4961l20.91 23.207c1.5938 1.7695 4.3711 1.7656 5.957-0.011719l42.098-47.199c1.4062-1.5781 1.3438-3.9766-0.14453-5.4766l-4.8867-4.9336c-1.6367-1.6523-4.3359-1.5625-5.8633 0.19531l-31.121 35.887c-1.6055 1.8516-4.4805 1.8398-6.0703-0.03125l-10.016-11.793c-1.5195-1.7852-4.2422-1.8906-5.8906-0.22656z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.cb711e5ee4c58e3040a8f0f8c0af1cf8.svg";
export { ForwardRef as ReactComponent };